import { lockUrlKey } from '@/util/lockRelease';

// Which record locks a second tab of this user also holds, as last pushed by the dashboard shared
// worker. A closing tab consults this synchronously: ClearLock is scoped to (record, user) with no
// notion of a tab, so releasing one of these would take the lock from the tab still using it.
// Empty when there is no worker (direct hubs), which correctly degrades to "release everything".
const sharedLockKeys = new Set<string>();

export function setSharedLockUrls(urls: string[] | null | undefined): void {
    sharedLockKeys.clear();
    for (const url of urls ?? []) sharedLockKeys.add(lockUrlKey(url));
}

export function isHeldByAnotherTab(url: string): boolean {
    return sharedLockKeys.has(lockUrlKey(url));
}
